import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {LocationDTO} from '../../clm/models/LocationDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private url = environment.baseUrl + '/location';

  constructor(private httpClient: HttpClient) {
  }

  getListOfLocations(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<LocationDTO>> {
    return this.httpClient.post<PagedResponseDTO<LocationDTO>>(this.url + '/filter', pagedRequestDTO);
  }
}
